import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/superpowers': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 32l-87.2 87c39.7 38.7 61.2 92.7 57.7 148.2-5.4 93-76.9 167.3-168.7 179.8-83.3 11-166.5 22-249.8 33l86.8-86.8c-39.8-38.7-61.1-92.7-57.8-148.2 5.7-93.3 77-167.5 169-180 83.2-11 166.7-22 250-33zM368.3 264.3c4.4-80-56.8-146.3-136.1-151-78.7-4.8-148.5 55.3-153 134.5-4.4 80 56.8 146.3 136.3 151 78.8 4.7 148.6-55 152.8-134.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/superpowers.js
// module id = 1045
// module chunks = 0